import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection, roleWriting } from '../../Data/All_Services_Data/angularDevelopmentData';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const AngularDevelopment = () => {
  useMetaTags({
    title: "Angular Development Company warrgyizmorsch ",
    description:
      "Searching for an Angular Development Company? Warrgyizmorsch builds intelligent, intuitive web applications that are fast, secure, and tailored to your requirements",
    keywords:
      "angular development company, angularjs development services, angular web development, angular js development, angular web app development, angularjs web app development, angularjs developers, hire dedicated angular developer, angular js web development company",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Angular Development Company
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/angular.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  We have years of experience as an Angular development company
                  which is in the business of creating robust,
                  scalable, and high performance web applications. Through the
                  power of Angular which is a very powerful JavaScript framework
                  we are able to create dynamic and responsive angular
                  development company applications that we tailor to your needs.
                  Our team of experts in Angular development see to it that your
                  projects are executed efficiently and delivered on time.
                  Whether you are after a single page application or a large
                  scale enterprise solution we use Angular to present innovative
                  solutions which will put your business at the front in the
                  competitive market.
                </p>
              </div>
            </div>
            {/* Leverage Our AngularJS Development Expertise for Your Next Project */}
            <Handle_Largedata_section LargeData={LargeData} />

            {/* Explore the Magic of AngularJS Development Services for Seamless Web Solutions  */}
            <Benefits_section data={BenefitSection} />

            {/* Leading Angular Development Solutions  */}
            <Boost_section data={BoostSection} />

            {/* Our AngularJS Development Approach  */}
            <Assistance_section data={AssistanceSection} />
            
            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default AngularDevelopment;